import { useState, useEffect } from 'react'
import { getKyousouApiClient, handleError, ApiErrorResponse } from '../../../../services/network'
import { useSnackBar } from '../../../../providers/snack_bar_provider'
import { SlideFaq } from './types'

export const useFaqDetail = (businessIdeaId: string) => {
  const apiClient = getKyousouApiClient()
  const { showSnackBar } = useSnackBar()
  const [slideFaq, setSlideFaq] = useState<SlideFaq | null>(null)
  const [isSlideFaqLoading, setIsSlideFaqLoading] = useState(false)

  const getSlideFaqDetail = async (id: string) => {
    if (!id) return

    setIsSlideFaqLoading(true)
    try {
      const response = await apiClient.business.slideFaqDetailList(id)
      setSlideFaq(response.data.faq)
    } catch (e) {
      console.error('FAQ・懸念点まとめの取得に失敗しました:', e)
      handleError(e as ApiErrorResponse, showSnackBar)
    } finally {
      setIsSlideFaqLoading(false)
    }
  }

  useEffect(() => {
    if (businessIdeaId) {
      getSlideFaqDetail(businessIdeaId)
    }
  }, [businessIdeaId])

  return {
    slideFaq,
    setSlideFaq,
    isSlideFaqLoading,
    getSlideFaqDetail,
  }
}
